import { useEffect, useRef, useState } from 'react';
import { Navigate } from 'react-router-dom';

import { Button, StatusView } from '@/components/ui';
import { useAuth } from '../AuthProvider';
import { Splash } from '../ProtectedRoute';

/**
 * Where the OAuth provider sends the user back.
 *
 * By this point Appwrite has already set the session cookie, so all this page
 * does is re-read the session and hand over to the app. If the session did not
 * materialise, it says so rather than bouncing the user in a redirect loop.
 */
export function OAuthCallbackPage() {
  const { status, refresh } = useAuth();
  const [checked, setChecked] = useState(false);
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    void refresh().finally(() => setChecked(true));
  }, [refresh]);

  if (status === 'authenticated') return <Navigate to="/" replace />;

  if (!checked) return <Splash label="Completing sign-in…" />;

  return (
    <StatusView
      icon="lock"
      tone="danger"
      title="Sign-in did not complete"
      message="The provider sent you back, but no ELA Lab session was created. This usually means the provider is not enabled for this project, or this origin is not on the project's platform list."
      action={
        <Button variant="primary" onClick={() => window.location.assign('/sign-in')}>
          Back to sign in
        </Button>
      }
    />
  );
}
